import { useQueryClient } from '@tanstack/react-query';
import { useCallActionState, reviewCallAction, acceptCallReview, joinReviewedCall } from '../call-actions';
import { isIncomingFor } from '../call-wire';
import { useTranslation } from '@/lib/i18n/react';
import { localizedErrorMessage } from '@/lib/i18n/errors';

/** Visible for an uncertain write on any route, even if its initiating modal
 * disappeared. Read-only review and separate acceptance never resend the action. */
export function CallRecovery() {
  const action = useCallActionState(s => s.action), qc = useQueryClient();
  const failure = useCallActionState(s => s.endFailure);
  const { t } = useTranslation('calls');
  if (!action && failure) return <div className="fixed top-4 inset-x-4 mx-auto z-[230] max-w-lg rounded-lg border border-border-subtle bg-surface p-4 shadow-xl" role="alert">
    <p className="text-sm">{localizedErrorMessage(failure, 'calls', 'api.unconfirmed')}</p>
    <button type="button" className="btn btn-secondary mt-3" onClick={() => useCallActionState.setState({ endFailure: null })}>{t('close')}</button>
  </div>;
  if (!action || action.phase === 'pending') return null;
  return <div className="fixed top-4 inset-x-4 mx-auto z-[230] max-w-lg rounded-lg border border-border-subtle bg-surface p-4 shadow-xl" role="status">
    <p className="text-sm">{t(action.phase === 'reviewed' ? 'recovery.observed' : 'api.unconfirmed')}</p>
    {action.phase === 'reviewed' && <p className="mt-2 text-sm font-semibold">{t(action.observed ? 'recovery.active' : 'recovery.none')}</p>}
    {action.failed && <p className="mt-2 text-sm text-red-500" role="alert">{t('api.read_failed')}</p>}
    <div className="mt-3 flex gap-2">
      <button type="button" className="btn btn-secondary" disabled={action.phase === 'reviewing'} onClick={() => void reviewCallAction(qc).catch(() => {})}>{t(action.phase === 'reviewing' ? 'recovery.reading' : 'recovery.review')}</button>
      {action.phase === 'reviewed' && <button type="button" className="btn btn-grad" onClick={acceptCallReview}>{t('recovery.continue')}</button>}
      {action.phase === 'reviewed' && action.observed && !isIncomingFor(action.observed, action.owner.user) && <button type="button" className="btn btn-secondary" onClick={() => void joinReviewedCall(qc).catch(() => {})}>{t('recovery.join')}</button>}
    </div>
  </div>;
}
